import { apiCall } from "./Interceptor";

const CREDIT_RATING_ALL = "/credit-rating/getAll/public";

const getAllCreditRating = async () => {
    const response = await apiCall.get(CREDIT_RATING_ALL);
    return response;
}

export default {
    getAllCreditRating,
};
